import { render } from "./TableHeader.vue?vue&type=template&id=2becdea3&scoped=true&ts=true"
import script from "./TableHeader.vue?vue&type=script&lang=ts"
export * from "./TableHeader.vue?vue&type=script&lang=ts"

import "./TableHeader.vue?vue&type=style&index=0&id=2becdea3&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2becdea3"]])

export default __exports__